import { SortFieldType } from 'seagull';
import { getUICompanyName } from './ArchivedProposalsDashboard.utils';
export const ARCHIVED_PROPOSALS_COLUMN_NAMES = [
    'companyName',
    'archivedBy',
    'archivedDate'
];
export const DEFAULT_ARCHIVED_PROPOSALS_SORT = {
    name: 'archivedDate',
    direction: 'desc'
};
export const toArchivedProposalRows = (param)=>{
    let { drafts, formatArchivedDate, unnamedDraftLabel } = param;
    return drafts.map((draft)=>{
        var _draft_lastModifiedBy, _draft_lastModifiedBy1;
        return {
            id: draft.id,
            companyName: getUICompanyName(draft),
            proposalTitle: "(".concat(draft.title || unnamedDraftLabel, ")"),
            archivedBy: "".concat((_draft_lastModifiedBy = draft.lastModifiedBy) === null || _draft_lastModifiedBy === void 0 ? void 0 : _draft_lastModifiedBy.firstName, " ").concat((_draft_lastModifiedBy1 = draft.lastModifiedBy) === null || _draft_lastModifiedBy1 === void 0 ? void 0 : _draft_lastModifiedBy1.lastName),
            archivedDate: formatArchivedDate(draft)
        };
    });
};
export const archivedProposalsColumns = (texts)=>[
        {
            type: 'text',
            name: 'companyName',
            header: texts.columns.companyName(),
            width: {
                initial: 180,
                min: 180
            },
            subtitle: (row)=>[
                    row.proposalTitle
                ],
            sortable: true,
            bi: {
                name: 'archived_proposals_by_company_name'
            }
        },
        {
            type: 'text',
            name: 'archivedBy',
            header: texts.columns.archivedBy(),
            width: {
                initial: 120,
                min: 120
            },
            sortable: true,
            bi: {
                name: 'archived_proposals_by_archived_by'
            }
        },
        {
            type: 'text',
            name: 'archivedDate',
            header: texts.columns.archivedDate(),
            width: {
                initial: 120,
                min: 120
            },
            sortable: true,
            bi: {
                name: 'archived_proposals_by_archived_date'
            }
        }
    ];
export var ArchivedProposalsColumnIds = /*#__PURE__*/ function(ArchivedProposalsColumnIds) {
    ArchivedProposalsColumnIds[ArchivedProposalsColumnIds["CompanyName"] = 0] = "CompanyName";
    ArchivedProposalsColumnIds[ArchivedProposalsColumnIds["ArchivedBy"] = 1] = "ArchivedBy";
    ArchivedProposalsColumnIds[ArchivedProposalsColumnIds["ArchivedDate"] = 2] = "ArchivedDate";
    return ArchivedProposalsColumnIds;
}({});
const COLUMN_ID_BY_NAME = {
    companyName: 0,
    archivedBy: 1,
    archivedDate: 2
};
export const toArchivedProposalsColumnId = (columnName)=>{
    var _COLUMN_ID_BY_NAME_columnName;
    return (_COLUMN_ID_BY_NAME_columnName = COLUMN_ID_BY_NAME[columnName]) !== null && _COLUMN_ID_BY_NAME_columnName !== void 0 ? _COLUMN_ID_BY_NAME_columnName : 2;
};
export const archivedProposalsSortColumnDefs = (columnTexts)=>({
        [0]: {
            label: columnTexts.companyName(),
            type: SortFieldType.String,
            getter: 'value',
            getValue: (draft)=>"".concat(getUICompanyName(draft), " ").concat(draft.title)
        },
        [1]: {
            label: columnTexts.archivedBy(),
            type: SortFieldType.String,
            getter: 'value',
            getValue: (draft)=>{
                var _ref, _ref1;
                var _draft_lastModifiedBy, _draft_lastModifiedBy1;
                return "".concat((_ref = (_draft_lastModifiedBy = draft.lastModifiedBy) === null || _draft_lastModifiedBy === void 0 ? void 0 : _draft_lastModifiedBy.firstName) !== null && _ref !== void 0 ? _ref : '', " ").concat((_ref1 = (_draft_lastModifiedBy1 = draft.lastModifiedBy) === null || _draft_lastModifiedBy1 === void 0 ? void 0 : _draft_lastModifiedBy1.lastName) !== null && _ref1 !== void 0 ? _ref1 : '');
            }
        },
        [2]: {
            label: columnTexts.archivedDate(),
            type: SortFieldType.Date,
            getter: 'path',
            path: 'lastModifiedOn'
        }
    });
